module.exports = __webpack_public_path__ + "lato-light-webfont.ecbd94f03d883ee5730b.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-light-webfont.eot
// module id = ../../../../../resources/fonts/lato-light-webfont.eot
// module chunks = styles